import { Component, EventEmitter, Input, OnDestroy, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilsService } from 'src/app/utils/utils.service';
import { DataService } from 'src/app/main/shared/services/data.service';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { isNullOrUndefined } from 'util';
import { SatelliteDataService } from '../services/satellite-data.service';
import { SatelliteMapService } from '../map/satellite-map.service';

@Component({
  selector: 'app-satellite-sidebar',
  templateUrl: './satellite-sidebar.component.html',
  styleUrls: ['./satellite-sidebar.component.scss']
})
export class SatelliteSidebarComponent implements OnInit, OnDestroy {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  selectedView: string = 'observed';
  queryParams: any = {};
  isInitialLoad: boolean = false;
  sessionStorage: any = { params: {} };
  private destroy$ = new Subject<void>();

  constructor(
    private utils: UtilsService,
    private dataService: DataService,
    public satelliteDataSrv: SatelliteDataService,
    private satelliteMapSrv: SatelliteMapService,
    private gisMapComp: GisDimsMapComponent
  ) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents();
    this.setParams();
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  subscribeEvents() {
    this.utils.selectedParams.pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        const previousLocType = this.queryParams['locType'];
        const previousPUUID  = this.queryParams['pUUID'];

        this.queryParams = params;

        const locTypeChanged = previousLocType !== undefined && this.queryParams['locType'] !== previousLocType;
        const pUUIDChanged   = previousPUUID  !== undefined && this.queryParams['pUUID']  !== previousPUUID;

        if (!this.isInitialLoad && (locTypeChanged || pUUIDChanged)) {
          this.requestSelectedFilterParams();
        }
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
    });
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = { ...this.queryParams };
    }
    currentUrlParams['component'] = 'SATELLITE';
    currentUrlParams['satelliteView'] = this.selectedView;
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      try {
        const userLocationConfig = this.dataService.formQuerParamsVariables(
          this.gisMapComp.metaInfo.userDetailsJson.data.location,
          this.gisMapComp.metaInfo.userDetailsJson.data.locType
        );
        const currentLocations: any = userLocationConfig.locationInfo[
          userLocationConfig.types.pType.toLowerCase()
        ].split('##');
        currentUrlParams['pUUID']    = currentLocations[1];
        currentUrlParams['locName']  = currentLocations[0];
        currentUrlParams['locType']  = userLocationConfig.types.pType;
        currentUrlParams['pEUUID']   = userLocationConfig.locationInfo.country.split('##')[1];
        currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      } catch (e) {
        currentUrlParams['locType']  = 'COUNTRY';
        currentUrlParams['pUUID']    = '00cb31c7-2928-4e6d-adcc-443d478c90d6';
        currentUrlParams['pEUUID']   = '00cb31c7-2928-4e6d-adcc-443d478c90d6';
        currentUrlParams['location'] = 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6';
        currentUrlParams['locName']  = 'India';
      }
      this.isInitialLoad = false;
    }
    this.utils.setSelectedParams(currentUrlParams);
  }

  onDateClick(dateKey: string) {
    this.satelliteMapSrv.selectDate(dateKey);
  }

  formatDateKey(dateKey: string): string {
    return this.satelliteDataSrv.formatDateKey(dateKey);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
